if (!customElements.get('cart-policy-consent')) {
  customElements.define(
    'cart-policy-consent',
    class CartPolicyConsent extends HTMLElement {
      connectedCallback() {
        const checkbox = this.querySelector('.cart__policy-consent-input[required]');
        const error = this.querySelector('#Cart-policy-consent-error');

        if (!checkbox || !error || checkbox.dataset.validationReady === 'true') return;

        checkbox.dataset.validationReady = 'true';

        checkbox.addEventListener(
          'invalid',
          (event) => {
            event.preventDefault();
            checkbox.setAttribute('aria-invalid', 'true');
            error.hidden = false;
            this.classList.add('cart__policy-consent-component--invalid');
          },
          true
        );

        checkbox.addEventListener('change', () => {
          if (!checkbox.checked) return;

          checkbox.removeAttribute('aria-invalid');
          error.hidden = true;
          this.classList.remove('cart__policy-consent-component--invalid');
        });
      }
    }
  );
}


const cartNoteAccordion = document.querySelector('.cart__note-accordion');

if (cartNoteAccordion) {
  const cartNoteInput = cartNoteAccordion.querySelector('.cart__note-input');
  const hasSavedNote = Boolean(cartNoteInput?.value.trim());

  cartNoteAccordion.open = window.matchMedia('(min-width: 750px)').matches || hasSavedNote;
}
